import BaseService from "./geral/BaseService";
import { observable } from "mobx";

const base = "Entreposto";

export default class EntrepostagemService extends BaseService{

    constructor(props){
        super(props)
    }

    ListarStatus = () => {
        return super.httpGet(`${base}/ListarStatus`);
    }
    
    ListarClientes = () => {
        return super.httpGet(`${base}/ListarClientes`);
    }

    ListarEntrepostagem = (clibrsId = null, indStatus="", ce = null, da = null) => {
        return super.httpGet(`${base}/ListarEntrepostagemRfb?clibrsId=${clibrsId}&indStatus=${indStatus}&ce=${ce}&da=${da}`);
    }


}


// WEBPACK FOOTER //
// ./src/services/EntrepostagemService.js